import React, { FunctionComponent, useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { InputOuter, HeadRadioContainer, HeadRadioLabel, RadioInput, InputContainer, InputLabel, TextInput, RadioContainer, RadioLabel, ZipCodeInput, TextArea, SubmitButton } from './form-components'

const Outer = styled.div`
  --require-background: #ed8599;
  --send-background: #00b2cc;
  width: 100%;
  margin-top: 2rem;
  
`

export const FormText = styled.div`
  margin-top: 3rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: -1rem;
  a {
    text-decoration: underline;
  }
`

type KengakuFormSectionProps = {

}
export const KengakuFormSection: FunctionComponent<KengakuFormSectionProps> = () => {
  const {executeRecaptcha} = useGoogleReCaptcha()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [school, setSchool] = useState('')

  const send = async () => {
    const formData = new FormData()
    formData.append('your-name', name)
    formData.append('email', email)
    formData.append('phone', phone)
    formData.append('school', school)

    if(executeRecaptcha){
      const token = await executeRecaptcha('homepage')
      if(token){
        formData.append('_wpcf7_recaptcha_response', token)
      }
    }

    const res = await fetch('http://www.muronokids-ninteikodomoen.jp/wp/wp-json/contact-form-7/v1/contact-forms/1805/feedback', {
      method: 'POST',
      body: formData
    }).then(res => res.json())
    // @ts-ignore
    alert(res.message)
    if(res.status === 'mail_sent'){
      setName('')
      setEmail('')
      setPhone('')
      setSchool('')
    }
  }

  return <Outer>
    <InputOuter>
      <InputContainer required>
        <InputLabel>お名前</InputLabel>
        <TextInput type="text" value={name} onChange={e => setName(e.currentTarget.value)}/>
      </InputContainer>
      <InputContainer required>
        <InputLabel>メールアドレス</InputLabel>
        <TextInput type="text" value={email} onChange={e => setEmail(e.currentTarget.value)}/>
      </InputContainer>
      <InputContainer required>
        <InputLabel>携帯電話番号</InputLabel>
        <TextInput type="text" value={phone} onChange={e => setPhone(e.currentTarget.value)}/>
      </InputContainer>
      <InputContainer required>
        <InputLabel>学校名</InputLabel>
        <TextInput type="text" value={school} onChange={e => setSchool(e.currentTarget.value)}/>
      </InputContainer>
      <FormText><Link to="/recruit/privacy-policy">プライバシーポリシー</Link>に同意の上送信してください。</FormText>
      <SubmitButton onClick={send}>送信</SubmitButton>
    </InputOuter>
  </Outer>
}